module.exports = __webpack_public_path__ + "static/media/realestate_bg.d938722e.png";